'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('Application error occurred:', error);
  }, [error]);

  return (
    <main className="root-status-page">
      <section className="root-status-card">
        <p className="root-status-code">Error</p>
        <h2>Something went wrong</h2>
        <p>Please try again or contact support if the problem persists.</p>
        <button type="button" onClick={reset} style={{ minHeight: '44px' }}>
          Try again
        </button>
      </section>
    </main>
  );
}
